import CustomCheckboxes from '@/components/UI/CustomCheckboxes.vue'
import ColorCheckboxes from '@/components/UI/ColorCheckboxes.vue'

export default [
 CustomCheckboxes,
 ColorCheckboxes,
];
